import { Box, Grid, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const FormLocationRow = ({
  edit,
  value,
}: {
  edit: boolean | null;
  value: string;
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation();

  return (
    <>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("talentProfile:zipCode")}
        </Typography>
      </Grid>
      <Grid item container xs={9} alignItems="center" gap={1}>
        {edit ? (
          <>
            <Box mr={1}>
              <Controller
                name="zip"
                control={control}
                rules={{
                  validate: {
                    onlyNumbers: (value) => /^\d+$/.test(value),
                    validLength: (value) => value && value.length === 5,
                  },
                }}
                render={({ field: { name, value, onChange } }) => (
                  <TextField
                    name={name}
                    inputProps={{ maxLength: 5 }}
                    sx={{ maxWidth: "96px" }}
                    fullWidth
                    size="small"
                    value={value}
                    error={!!errors[name]}
                    onChange={onChange}
                  />
                )}
              />
            </Box>
            <Typography textAlign="end" variant="secondary">
              {t("talentProfile:city")}
            </Typography>
            <Controller
              name="city"
              control={control}
              rules={{ required: true }}
              render={({ field: { name, value, onChange } }) => (
                <TextField
                  name={name}
                  error={!!errors[name]}
                  sx={{ maxWidth: "260px" }}
                  fullWidth
                  size="small"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </>
        ) : (
          <Typography>{value}</Typography>
        )}
      </Grid>
    </>
  );
};

export default FormLocationRow;
